// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__CfI3F","navLinkActive":"Nav_navLinkActive__fawD+"};